<template>
    <JetFormSection @submitted="updateProfileInformation">
        <template #title>
            User Categories
        </template>

        <template #description>
            Update the types of categories you will be selling.
        </template>

        <template #form>
            <!-- Categories -->
            <div class="col-span-6 sm:col-span-4">
                <Multiselect
                    v-model="selectedCategories"
                    :options="categories"
                    :multiple="true"
                    :close-on-select="false"
                    placeholder="Pick some"
                    label="name"
                    track-by="name"
                />
            </div>
        </template>

        <template #actions>
            <JetActionMessage
                :on="form.recentlySuccessful"
                class="mr-3"
            >
                Saved.
            </JetActionMessage>

            <JetButton
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
            >
                Save
            </JetButton>
        </template>
    </JetFormSection>
</template>

<script>
import Multiselect from 'vue-multiselect';
import JetFormSection from '../Jetstream/FormSection.vue';
import JetActionMessage from '../Jetstream/ActionMessage.vue';
import JetButton from '../Jetstream/Button.vue';

export default {
    name: 'UpdateCategories',

    components: {
        JetActionMessage,
        JetButton,
        JetFormSection,
        Multiselect,
    },

    // eslint-disable-next-line vue/require-prop-types
    props: ['user'],

    data() {
        return {
            selectedCategories: this.$page.props.userRootCategories.length ? this.$page.props.userRootCategories.map((rootCategory) => rootCategory) : [],

            form: this.$inertia.form({
                categoryIds: this.$page.props.userRootCategories.length ? this.$page.props.userRootCategories.map((rootCategory) => parseInt(rootCategory.id)) : [],
            }),

            categories: [],
        };
    },

    watch: {
        selectedCategories: {
            deep: true,
            handler() {
                this.form.categoryIds = this.selectedCategories.map((category) => category.id);
            },
        },
    },

    mounted() {
        this.fetchRootCategories();
    },

    methods: {
        updateProfileInformation() {
            this.form.post(route('user.updateCategories'));
        },

        fetchRootCategories() {
            this.$axios.get(route('categories.parent')).then((res) => {
                this.categories = res.data.categories;
            });
        },
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
